import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import PageToggleButton from '../../../Common/PageToggleButton';
import { Pagination } from '@mui/material';
import ARService from './ARService';
import '../actualsStyles.scss';
import ARModal from './ARSaveModal';
import { styled } from '@mui/material/styles';
import { Button } from 'react-bootstrap';
import moment from 'moment-timezone';
import { Config } from '../../../../shared/config';

const DivButton = styled('div')`
    padding-top: 10px;
`;

const SearchFilters = styled('div')`
    display: flex;
    gap: 10px;
    padding-right: 5px;
    overflow: auto;
    justify-content: end;
`;

const filterArrRes = [];

class ARManagementList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ARManagementData: [],
            noRecordsMessage: null,
            showPagination: false,
            rowsPerPage: 10,
            page: 1,
            totalCount: 0,
            total: 0,
            filterInUse: false,
            showARModal: false,
            showDisableARModal: false,
            showSaveARModal: false,
            depSelected: [],
            classSelected: [],
            specialtySelected: [],
            locationName: '',
            departmentFilter: [{ label: 'All' }],
            thereapeuticClassFilter: [{ label: 'All' }],
            specialtyTypeFilter: [{ label: 'All' }],
        };
        this.arService = new ARService();
    }

    refresh = (
        setSelectedDepartment,
        setSelectedClass,
        setSelectedSpecialtyType,
        customerId,
        userFullname,
        action,
        depSelected,
    ) => {
        const selectedDepartment = Array.isArray(setSelectedDepartment)
            ? setSelectedDepartment
            : [setSelectedDepartment];
        const selectedClass = Array.isArray(setSelectedClass) ? setSelectedClass : [setSelectedClass];
        const selectedSpecialtyType = Array.isArray(setSelectedSpecialtyType)
            ? setSelectedSpecialtyType
            : [setSelectedSpecialtyType];

        if (action == 'Save') {
            selectedDepartment.forEach((depItem) => {
                selectedClass.forEach((classItem) => {
                    selectedSpecialtyType.forEach((item) => {
                        this.arService
                            .saveARConfig({
                                vistaReferralConfig: {
                                    department_id: depItem.id,
                                    customer_id: customerId,
                                    therapeutic_class_id: classItem.id,
                                    specialty_type: item.label,
                                    enabled: 1,
                                    created_by: userFullname,
                                    modified_by: userFullname,
                                },
                            })
                            .then((res) => {
                                this.callRefresh(res);
                                this.getAllVRCFilter(customerId, null);
                            });
                    });
                });
            });
        }

        if (action == 'Update') {
            this.arService
                .disableARConfig({
                    vistaReferralConfig: {
                        department_id: depSelected.id,
                        customer_id: customerId,
                        therapeutic_class_id: 0,
                        specialty_type: '',
                        enabled: 0,
                        created_by: userFullname,
                        modified_by: userFullname,
                    },
                })
                .then(() => {
                    setSelectedClass.forEach((classItem) => {
                        setSelectedSpecialtyType.forEach((item) => {
                            this.arService
                                .updateARConfig({
                                    vistaReferralConfig: {
                                        department_id: depSelected.id,
                                        customer_id: customerId,
                                        therapeutic_class_id: classItem.id,
                                        specialty_type: item.label,
                                        enabled: 1,
                                        created_by: userFullname,
                                        modified_by: userFullname,
                                    },
                                })
                                .then((res) => {
                                    this.callRefresh(res);
                                    this.getAllVRCFilter(customerId, null);
                                });
                        });
                    });
                });
        }

        if (action == 'Disable') {
            this.arService
                .disableARConfig({
                    vistaReferralConfig: {
                        department_id: depSelected.id,
                        customer_id: customerId,
                        therapeutic_class_id: 0,
                        specialty_type: '',
                        enabled: 0,
                        created_by: userFullname,
                        modified_by: userFullname,
                    },
                })
                .then((res) => {
                    this.callRefresh(res);
                    this.getAllVRCFilter(customerId, null);
                });
        }
    };

    callRefresh = (res) => {
        const { rowsPerPage } = this.state;
        if (res && res.status === 'Success' && res.data) {
            const { totalPages, data, total } = paginateUI(res.data, rowsPerPage, 1);
            this.setState({
                ARManagementData: data,
                noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                page: 1,
                totalCount: totalPages,
                total: total,
                showARModal: false,
                showDisableARModal: false,
                showSaveARModal: false,
            });
        } else {
            this.setState({
                ARManagementData: [],
                noRecordsMessage: '-No Result Found-',
                showARModal: false,
                showDisableARModal: false,
                showSaveARModal: false,
            });
        }
    };

    searchLocation = (search) => {
        const { customerId } = this.props;
        console.log('serachLocation', search);
        this.getAllVRCFilter(customerId, search);
    };

    closeModal = () => {
        this.setState({
            showARModal: false,
            showDisableARModal: false,
            showSaveARModal: false,
        });
    };

    setShowARModal = () => {
        const { customerId } = this.props;
        this.arService.vistaReferralConfig(customerId).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                const { totalPages, data, total } = paginateUI(res.data, 10, 1);
                this.setState({
                    ARManagementData: data,
                    noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                    page: 1,
                    totalCount: totalPages,
                    total: total,
                    showARModal: false,
                    showDisableARModal: false,
                });
            } else {
                this.setState({
                    ARManagementData: [],
                    noRecordsMessage: '-No Customers Found-',
                    showARModal: false,
                    showDisableARModal: false,
                });
            }
        });
    };
    /**
     * Ui elements rendering
     */

    setShowARModals = () => {
        this.setState({
            showSaveARModal: true,
        });
    };

    render() {
        const {
            ARManagementData,
            noRecordsMessage,
            showPagination,
            totalCount,
            page,
            rowsPerPage,
            filterInUse,
            showARModal,
            showDisableARModal,
            showSaveARModal,
            depSelected,
            classSelected,
            specialtySelected,
            locationName,
            departmentFilter,
            thereapeuticClassFilter,
            specialtyTypeFilter,
        } = this.state;
        const { customerId, userFullname } = this.props;
        return (
            <div className="model-list-box">
                <SearchFilters>
                    <DivButton>
                        <Button className="text-center btn-sm" onClick={() => this.setShowARModals(true)}>
                            <span className="ml-2">Add AR Location</span>
                        </Button>
                    </DivButton>
                    {showSaveARModal && (
                        <ARModal
                            action="Save"
                            show={showSaveARModal}
                            header="Add AR Location"
                            thereapeuticClassFilter={thereapeuticClassFilter}
                            departmentFilter={departmentFilter}
                            specialtyTypeFilter={specialtyTypeFilter}
                            customerId={customerId}
                            userFullname={userFullname}
                            selected={[]}
                            specialtySelected={[]}
                            refresh={this.refresh}
                            closeModal={this.closeModal}
                            searchLocation={this.searchLocation}
                        />
                    )}
                </SearchFilters>
                <div className="table-responsive-cm">
                    {showARModal && (
                        <ARModal
                            show={showARModal}
                            header="Update AR Location"
                            action="Update"
                            setShowARModal={this.setShowARModal}
                            thereapeuticClassFilter={thereapeuticClassFilter}
                            departmentFilter={departmentFilter}
                            specialtyTypeFilter={specialtyTypeFilter}
                            customerId={customerId}
                            userFullname={userFullname}
                            depSelected={depSelected}
                            classSelected={classSelected}
                            specialtySelected={specialtySelected}
                            refresh={this.refresh}
                            closeModal={this.closeModal}
                            location={locationName}
                        />
                    )}
                    {showDisableARModal && (
                        <ARModal
                            show={showDisableARModal}
                            header="Remove AR Location"
                            action="Disable"
                            setShowARModal={this.setShowARModal}
                            thereapeuticClassFilter={thereapeuticClassFilter}
                            departmentFilter={departmentFilter}
                            specialtyTypeFilter={specialtyTypeFilter}
                            customerId={customerId}
                            userFullname={userFullname}
                            location={locationName}
                            depSelected={depSelected}
                            classSelected={classSelected}
                            specialtySelected={specialtySelected}
                            refresh={this.refresh}
                            closeModal={this.closeModal}
                        />
                    )}
                    <ReactTable
                        filterable
                        defaultFilterMethod={(filter, row) =>
                            row[filter.id] !== undefined
                                ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                : false
                        }
                        columns={[
                            {
                                Header: 'Department/Location',
                                accessor: 'locationName',
                                width: 300,
                                Filter: ({ filter, onChange }) => this.filterRender(filter, onChange, 'locationName'),
                            },
                            {
                                Header: 'Specialty Type',
                                accessor: 'specialtyName',
                                width: 280,
                                Filter: ({ filter, onChange }) => this.filterRender(filter, onChange, 'specialtyName'),
                            },
                            {
                                Header: 'Specialty Menu',
                                accessor: 'specialtyNameDropDown',
                                width: 0,
                                show: false,
                                Filter: ({ filter, onChange }) => this.filterRender(filter, onChange, 'specialtyName'),
                            },
                            {
                                Header: 'Therapeutic Class',
                                accessor: 'therapeuticClassName',
                                width: 500,
                                Filter: ({ filter, onChange }) =>
                                    this.filterRender(filter, onChange, 'therapeuticClassName'),
                            },
                            {
                                Header: 'Modified By',
                                accessor: 'modifiedBy',
                                width: 200,
                                Filter: ({ filter, onChange }) => this.filterRender(filter, onChange, 'modifiedBy'),
                            },
                            {
                                Header: 'Modified Date',
                                accessor: 'modifiedDate',
                                Cell: (props) => {
                                    const modifiedDate = props.value
                                        ? moment.utc(props.value, Config.UI_TIMESTAMP_FORMAT).local()
                                        : '';
                                    return props.value
                                        ? moment(modifiedDate, Config.API_TIMESTAMP_FORMAT).format(
                                              Config.UI_TIMESTAMP_FORMAT,
                                          )
                                        : '';
                                },
                                sortMethod: (a, b) => {
                                    var a1 = new Date(a).getTime();
                                    var b1 = new Date(b).getTime();
                                    if (a1 > b1) return 1;
                                    else if (a1 < b1) return -1;
                                    else return 0;
                                },
                                Filter: ({ filter, onChange }) => this.filterRender(filter, onChange, 'modifiedDate'),
                            },
                            {
                                Header: () => <div style={{ textAlign: 'center' }}>Action</div>,
                                Cell: MyCell,
                                getProps: (state, rowInfo) => ({
                                    onUpdateClick: () => {
                                        this.tableRowUpdateClick(rowInfo);
                                    },
                                    onDisableClick: () => {
                                        this.tableRowDisableClick(rowInfo);
                                    },
                                    update: 'Update',
                                    delete: 'Delete',
                                }),
                                className: 'td-button-outer',
                                minWidth: 110,
                                width: 190,
                                filterable: false,
                            },
                        ]}
                        data={ARManagementData}
                        noDataText={noRecordsMessage}
                        minRows={ARManagementData.length}
                        showPagination={showPagination}
                        pageSize={ARManagementData.length}
                        className="-highlight cursor-pointer w-100"
                        style={
                            ARManagementData.length >= 1
                                ? {
                                      height: 'calc(100vh - 320px)',
                                  }
                                : {}
                        }
                        defaultSorted={[{ id: 'modifiedDate', desc: true }]}
                    />
                </div>
                <div className="pagination-div">
                    <Pagination
                        showFirstButton
                        showLastButton
                        disabled={filterInUse}
                        component="div"
                        count={totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onChange={this.handleChangePage}
                        variant="outlined"
                        shape="rounded"
                        sx={{
                            '.MuiPaginationItem-root': {
                                fontSize: '16px',
                                marginTop: '15px',
                            },
                            '.Mui-selected': {
                                backgroundColor: '#135d87 !important',
                                color: '#fff',
                            },
                        }}
                    />
                    <PageToggleButton
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        filterInUse={filterInUse}
                        perPageCount={rowsPerPage}
                        rowsPerPage={(perPage) => {
                            this.setState({ rowsPerPage: perPage });
                            this.onPageOrPageLoadChange(1, perPage);
                        }}
                    />
                </div>
            </div>
        );
    }

    /**
     * On row click
     * @param {*} rowInfo row information
     */
    tableRowUpdateClick(rowInfo) {
        const { thereapeuticClassFilter, specialtyTypeFilter } = this.state;
        const {
            row: { locationName, therapeuticClassName, specialtyNameDropDown },
            original: { departmentId },
        } = rowInfo;

        const department = { id: departmentId, name: locationName };

        const therapeuticArray = therapeuticClassName.split(',');
        let therapeuticObj = [];
        therapeuticArray.forEach((value) => {
            therapeuticObj.push(thereapeuticClassFilter[thereapeuticClassFilter.findIndex((x) => x.label == value)]);
        });

        const specialtyArray = specialtyNameDropDown.split(',,+');
        let specialtyObj = [];
        specialtyArray.forEach((value) => {
            specialtyObj.push(specialtyTypeFilter[specialtyTypeFilter.findIndex((x) => x.label == value)]);
        });

        this.setState({
            showARModal: true,
            depSelected: department,
            specialtySelected: specialtyObj,
            classSelected: therapeuticObj,
            locationName: locationName,
        });
    }

    /**
     * On row click
     * @param {*} rowInfo row information
     */
    tableRowDisableClick(rowInfo) {
        const { thereapeuticClassFilter, specialtyTypeFilter } = this.state;
        const {
            row: { locationName, specialtyName, therapeuticClassName },
            original: { departmentId },
        } = rowInfo;

        const department = { id: departmentId, name: locationName };

        const therapeuticArray = therapeuticClassName.split(',');
        let therapeuticObj = [];
        therapeuticArray.forEach((value) => {
            therapeuticObj.push(thereapeuticClassFilter[thereapeuticClassFilter.findIndex((x) => x.label == value)]);
        });

        const specialtyArray = specialtyName.split(',');
        let specialtyObj = [];
        specialtyArray.forEach((value) => {
            specialtyObj.push(specialtyTypeFilter[specialtyTypeFilter.findIndex((x) => x.label == value)]);
        });

        this.setState({
            showDisableARModal: true,
            depSelected: department,
            classSelected: therapeuticObj,
            specialtySelected: specialtyObj,
            locationName: locationName,
        });
    }

    /**
     * Component mount method
     */
    componentDidMount() {
        const { customerId } = this.props;
        this.arService.vistaReferralConfig(customerId).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                const { totalPages, data, total } = paginateUI(res.data, 10, 1);
                this.setState({
                    ARManagementData: data,
                    noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                    page: 1,
                    totalCount: totalPages,
                    total: total,
                });
            } else {
                this.setState({
                    ARManagementData: [],
                    noRecordsMessage: '-No Result Found-',
                });
            }
        });

        this.getAllVRCFilter(customerId, null);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customerId !== this.props.customerId) {
            this.arService.vistaReferralConfig(this.props.customerId).then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    const { totalPages, data, total } = paginateUI(res.data, 10, 1);
                    this.setState({
                        ARManagementData: data,
                        noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                        page: 1,
                        totalCount: totalPages,
                        total: total,
                    });
                } else {
                    this.setState({
                        ARManagementData: [],
                        noRecordsMessage: '-No Result Found-',
                    });
                }
            });

            this.getAllVRCFilter(this.props.customerId, null);
        }
    }

    getAllVRCFilter(customerId, search) {
        this.arService.getAllVRCFilter(customerId, search).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                const { departmentFilter, thereapeuticClassFilter, specialtyTypeFilter } = res.data;
                this.setState({
                    departmentFilter: departmentFilter,
                    thereapeuticClassFilter: thereapeuticClassFilter,
                    specialtyTypeFilter: specialtyTypeFilter,
                });
            } else {
                this.setState({
                    departmentFilter: [{ label: 'All' }],
                    thereapeuticClassFilter: [{ label: 'All' }],
                    specialtyTypeFilter: [{ label: 'All' }],
                });
            }
        });
    }

    async onPageOrPageLoadChange(newPage, perPage) {
        const { customerId } = this.props;
        if (perPage) {
            this.arService.vistaReferralConfig(customerId).then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    const { data, totalPages } = paginateUI(res.data, perPage, newPage);
                    this.setState({
                        ARManagementData: data,
                        noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                        totalCount: totalPages,
                        page: parseInt(newPage, 10),
                    });
                } else {
                    this.setState({
                        ARManagementData: [],
                        noRecordsMessage: '-No Customers Found-',
                    });
                }
            });
        }
    }

    handleChangePage = async (event, newPage) => {
        const { customerId } = this.props;
        this.setState({ page: newPage });
        this.arService.vistaReferralConfig(customerId).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                const { data } = paginateUI(res.data, this.state.rowsPerPage, newPage);
                this.setState({
                    ARManagementData: data,
                    noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                });
            } else {
                this.setState({
                    ARManagementData: [],
                    noRecordsMessage: '-No Result Found-',
                });
            }
        });
    };

    onFilterRenderChange = async (event, field) => {
        const { ARManagementData, total, rowsPerPage, page } = this.state;
        const { customerId } = this.props;
        if (field) {
            if (!event.target.value) {
                filterArrRes.pop(field);
            } else if (!filterArrRes.includes(field)) {
                filterArrRes.push(field);
            }
        }
        if (!event.target.value && filterArrRes.length == 0) {
            const { data } = await paginateUI(ARManagementData, rowsPerPage, page);
            if (data && data.length > 0) {
                this.setState({
                    ARManagementData: data,
                    filterInUse: false,
                });
            }
        } else if (ARManagementData.length != total) {
            this.arService.vistaReferralConfig(customerId).then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    this.setState({
                        ARManagementData: res.data,
                        filterInUse: true,
                    });
                }
            });
        }
    };

    filterRender = (filter, onChange, field) => {
        return (
            <div style={{ position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px' }}>
                <FontAwesomeIcon icon={faSearch} className="filter-search-icon" />
                <input
                    onChange={(event) => {
                        onChange(event.target.value);
                        this.onFilterRenderChange(event, field);
                    }}
                    value={filter ? filter.value : ''}
                    style={{
                        width: '100%',
                        border: '0px',
                    }}
                />
            </div>
        );
    };
}

const paginateUI = (items, perPage, page) => {
    const offset = perPage * (page - 1);
    const totalPages = Math.ceil(items.length / perPage);
    const paginatedItems = items.slice(offset, perPage * page);

    return {
        previousPage: page - 1 ? page - 1 : null,
        nextPage: totalPages > page ? page + 1 : null,
        total: items.length,
        totalPages: totalPages,
        data: paginatedItems,
    };
};

ARManagementList.propTypes = {
    customerId: PropTypes.object.isRequired,
    userFullname: PropTypes.object.isRequired,
    departmentFilter: PropTypes.object.isRequired,
    thereapeuticClassFilter: PropTypes.object.isRequired,
    specialtyTypeFilter: PropTypes.object.isRequired,
    refresh: PropTypes.object.isRequired,
};

export default withRouter(ARManagementList);

/**
 * To return button elements
 * @param {*} param0 Cell info
 */
export function MyCell({
    columnProps: {
        rest: { onUpdateClick, onDisableClick },
    },
}) {
    return (
        <Row>
            <Col md={12} className="text-center table-buttons">
                <button className="btn-view" id="view-btn" value="update" onClick={onUpdateClick}>
                    Update
                </button>

                <button
                    className="btn-view button-padding-right"
                    id="view-btn"
                    value="disable"
                    onClick={onDisableClick}
                >
                    Remove
                </button>
            </Col>
        </Row>
    );
}
MyCell.propTypes = {
    columnProps: PropTypes.shape({
        rest: PropTypes.shape({
            onUpdateClick: PropTypes.func,
            onDisableClick: PropTypes.func,
            onDeleteClick: PropTypes.func,
            onClickRename: PropTypes.func,
        }),
    }),
};
